import { createActionCreators, createActionTypes } from "../../utils/reduxUtils"

const typesActions = [
    'GET_CSV_REQUEST',
    'GET_CSV_SUCCESS',
    'GET_CSV_FAILURE'
]
export const Actions = createActionCreators(typesActions);
export const ActionsTypes = createActionTypes(typesActions);